import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getAverageFulfillmentPerHour = {
  name: "getAverageFulfillmentPerHour" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
